import React, { useState, useEffect, useRef } from 'react';
import Tooltip from './../../components/Tooltip/index';

const TruncatedTextWithTooltip = ({ content, className, maxWidth = 200, placement = "top" }) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    const element = textRef.current;
    if (element) {
      setIsTruncated(element.scrollWidth > element.clientWidth);
    }
  }, [content, maxWidth]);

  return (
    <Tooltip placement={placement} disabled={!isTruncated} content={content}>
      <div
        ref={textRef}
        className={className}
        style={{ 
          maxWidth: `${maxWidth}px`, 
          display: "inline-block",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }}
      >
        {content}
      </div>
    </Tooltip>
  )
}

export default TruncatedTextWithTooltip;